import React from 'react';
import DragHandle, {
  HANDLE_POSITIONS
} from '../../../components/wysiwyg_editor/page_content_items/DragHandle';
import { animated } from '@react-spring/web';
import type { TSprungOverlayLocations } from '../../../utils/wysiwyg_editor/contentItemHandleLocations';

type TProps = {
  pageItemId: string;
  noHandles?: boolean;
  locations: TSprungOverlayLocations;
  zIndex: number;
  onDrag: (position: string, movement: [number, number]) => void;
  onDragStart: (position: string) => void;
  onDragStop: () => void;
};

function DragFrame(props: TProps): React.ReactElement {
  return (
    <div>
      <animated.div
        style={{
          left: props.locations.frameLeftX,
          background: '#3091EC',
          top: props.locations.frameLeftY,
          height: props.locations.frameLeftHeight,
          width: props.locations.frameLeftWidth,
          position: 'absolute',
          zIndex: props.zIndex
        }}
      />
      <animated.div
        style={{
          left: props.locations.frameRightX,
          background: '#3091EC',
          top: props.locations.frameRightY,
          height: props.locations.frameRightHeight,
          width: props.locations.frameRightWidth,
          position: 'absolute',
          zIndex: props.zIndex
        }}
      />
      <animated.div
        style={{
          left: props.locations.frameTopX,
          width: props.locations.frameTopWidth,
          background: '#3091EC',
          top: props.locations.frameTopY,
          height: props.locations.frameTopHeight,
          position: 'absolute',
          zIndex: props.zIndex
        }}
      />
      <animated.div
        style={{
          left: props.locations.frameBottomX,
          width: props.locations.frameBottomWidth,
          background: '#3091EC',
          top: props.locations.frameBottomY,
          height: props.locations.frameBottomHeight,
          position: 'absolute',
          zIndex: props.zIndex
        }}
      />

      {props.noHandles
        ? null
        : [
            <DragHandle
              key="nw"
              top={props.locations.handleNwY}
              left={props.locations.handleNwX}
              height={props.locations.handleNwHeight}
              width={props.locations.handleNwWidth}
              paddedTop={props.locations.handlePaddedNwY}
              paddedLeft={props.locations.handlePaddedNwX}
              paddedHeight={props.locations.handlePaddedNwHeight}
              paddedWidth={props.locations.handlePaddedNwWidth}
              zIndex={props.zIndex}
              pageItemId={props.pageItemId}
              position={HANDLE_POSITIONS.nw}
              onDrag={props.onDrag}
              onDragStart={props.onDragStart}
              onDragStop={props.onDragStop}
            />,
            <DragHandle
              key="sw"
              top={props.locations.handleSwY}
              left={props.locations.handleSwX}
              height={props.locations.handleSwHeight}
              width={props.locations.handleSwWidth}
              paddedTop={props.locations.handlePaddedSwY}
              paddedLeft={props.locations.handlePaddedSwX}
              paddedHeight={props.locations.handlePaddedSwHeight}
              paddedWidth={props.locations.handlePaddedSwWidth}
              zIndex={props.zIndex}
              pageItemId={props.pageItemId}
              position={HANDLE_POSITIONS.sw}
              onDrag={props.onDrag}
              onDragStart={props.onDragStart}
              onDragStop={props.onDragStop}
            />,
            <DragHandle
              key="w"
              top={props.locations.handleWY}
              left={props.locations.handleWX}
              height={props.locations.handleWHeight}
              width={props.locations.handleWWidth}
              paddedTop={props.locations.handlePaddedWY}
              paddedLeft={props.locations.handlePaddedWX}
              paddedHeight={props.locations.handlePaddedWHeight}
              paddedWidth={props.locations.handlePaddedWWidth}
              zIndex={props.zIndex}
              pageItemId={props.pageItemId}
              position={HANDLE_POSITIONS.w}
              onDrag={props.onDrag}
              onDragStart={props.onDragStart}
              onDragStop={props.onDragStop}
            />,
            <DragHandle
              key="ne"
              top={props.locations.handleNeY}
              left={props.locations.handleNeX}
              height={props.locations.handleNeHeight}
              width={props.locations.handleNeWidth}
              paddedTop={props.locations.handlePaddedNeY}
              paddedLeft={props.locations.handlePaddedNeX}
              paddedHeight={props.locations.handlePaddedNeHeight}
              paddedWidth={props.locations.handlePaddedNeWidth}
              zIndex={props.zIndex}
              pageItemId={props.pageItemId}
              position={HANDLE_POSITIONS.ne}
              onDrag={props.onDrag}
              onDragStart={props.onDragStart}
              onDragStop={props.onDragStop}
            />,
            <DragHandle
              key="se"
              top={props.locations.handleSeY}
              left={props.locations.handleSeX}
              height={props.locations.handleSeHeight}
              width={props.locations.handleSeWidth}
              paddedTop={props.locations.handlePaddedSeY}
              paddedLeft={props.locations.handlePaddedSeX}
              paddedHeight={props.locations.handlePaddedSeHeight}
              paddedWidth={props.locations.handlePaddedSeWidth}
              zIndex={props.zIndex}
              pageItemId={props.pageItemId}
              position={HANDLE_POSITIONS.se}
              onDrag={props.onDrag}
              onDragStart={props.onDragStart}
              onDragStop={props.onDragStop}
            />,
            <DragHandle
              key="e"
              top={props.locations.handleEY}
              left={props.locations.handleEX}
              height={props.locations.handleEHeight}
              width={props.locations.handleEWidth}
              paddedTop={props.locations.handlePaddedEY}
              paddedLeft={props.locations.handlePaddedEX}
              paddedHeight={props.locations.handlePaddedEHeight}
              paddedWidth={props.locations.handlePaddedEWidth}
              zIndex={props.zIndex}
              pageItemId={props.pageItemId}
              position={HANDLE_POSITIONS.e}
              onDrag={props.onDrag}
              onDragStart={props.onDragStart}
              onDragStop={props.onDragStop}
            />,
            <DragHandle
              key="s"
              top={props.locations.handleSY}
              left={props.locations.handleSX}
              height={props.locations.handleSHeight}
              width={props.locations.handleSWidth}
              paddedTop={props.locations.handlePaddedSY}
              paddedLeft={props.locations.handlePaddedSX}
              paddedHeight={props.locations.handlePaddedSHeight}
              paddedWidth={props.locations.handlePaddedSWidth}
              zIndex={props.zIndex}
              pageItemId={props.pageItemId}
              position={HANDLE_POSITIONS.s}
              onDrag={props.onDrag}
              onDragStart={props.onDragStart}
              onDragStop={props.onDragStop}
            />,
            <DragHandle
              key="n"
              top={props.locations.handleNY}
              left={props.locations.handleNX}
              height={props.locations.handleNHeight}
              width={props.locations.handleNWidth}
              paddedTop={props.locations.handlePaddedNY}
              paddedLeft={props.locations.handlePaddedNX}
              paddedHeight={props.locations.handlePaddedNHeight}
              paddedWidth={props.locations.handlePaddedNWidth}
              zIndex={props.zIndex}
              pageItemId={props.pageItemId}
              position={HANDLE_POSITIONS.n}
              onDrag={props.onDrag}
              onDragStart={props.onDragStart}
              onDragStop={props.onDragStop}
            />
          ]}
    </div>
  );
}

export default DragFrame;
